define(function (require) {
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	return IpsModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/crm/setup/{1}servicerequesttypes?filter={property:type,value:{0}}&Page=[{Max:0}]',
		url: function () {
			var useAccount = '';
			if( this.IsForBilling === true ){
				useAccount = 'account/'
			}
			return this.urlRoot.format(this.encodeComponent(this.instTypeCode), useAccount);
		},
		hasPortalDetail: function () {
			var keys = [];
			if (!this.models[0]) {
				return false;
			}
			var types = this.models[0].get('detailTypes');
			if (types && types.models) {
				_.forEach(types.models, t => {
					var display = t.get('display');
					if (!_.isNull(display) && _.parseInt(display) === 2) {
						keys.push(t.id);
					}
				});
			}
			return keys.length > 0;
		},
		hasContactDetail: function () {
		 if(this.useEmbeddedDetailPages){
				var hasDetails = false;
				//do we have data to look at
				if (!this.models[0]) {
					return hasDetails;
				}

				var types = this.models[0].get('detailTypes');
				if (types && types.models) {
					_.forEach(types.models, t => {
						var portalDetailArea = t.get('portalDetailArea');
						let display = t.get('display');
						if (!_.isNull(display) && _.parseInt(display) === 2 && !_.isNull(portalDetailArea) && portalDetailArea.indexOf('Contact')>-1) {
							hasDetails = true;
						}
					});
				}
				return hasDetails;
			}
		},
		hasSiteDetails: function () {
			if(this.useEmbeddedDetailPages){
				   var hasDetails = false;
				   //do we have data to look at
				   if (!this.models[0]) {
					   return hasDetails;
				   }
   
				   var types = this.models[0].get('detailTypes');
				   if (types && types.models) {
					   _.forEach(types.models, t => {
						   var portalDetailArea = t.get('portalDetailArea');
						   let display = t.get('display');
						   if (!_.isNull(display) && _.parseInt(display) ===2 && !_.isNull(portalDetailArea) && portalDetailArea.indexOf('Sites')>-1) {
							   hasDetails = true;
						   }
					   });
				   }
				   return hasDetails;
			   }
		   },
		parse: function (response) {
			if (this.useEmbeddedDetailPages && response.data && response.data[0].detailTypes) {
				for (i = 0; i < response.data[0].detailTypes.length; i++) {
					//append area and placement
					var area = response.data[0].detailTypes[i].portalDetailArea;
					var placement = response.data[0].detailTypes[i].portalDetailPlacement;
					response.data[0].detailTypes[i].portalSubmitPlacement = area + placement;
				}
			}
			return response.data;
		}
	});
});
